<template lang="pug">
  // TABLE that displays CRM
  div
    p(v-if='loading')
    app-table(:data='tableItems', :label='tableFields', v-else)
</template>

<script>
import { db } from '@/firebase'
// import numeral from 'numeral'

const customRef = db.ref('custom')

export default {
  name: 'crm-table',
  data() {
    return {
      cls: {},
      loading: true,
      tableItems: [
      ],
      tableFields: {
        messageId: {
          label: 'ID',
        },
        endDate: {
          label: 'Name',
        },
        startDate: {
          label: 'Date',
          sortable: true,
          thStyle: {
            minWidth: '8em',
          },
        },
        topic: {
          label: 'Time',
        },
        phoneID: {
          label: 'Mobile No',
        },
        timestamp: {
          label: 'Timestamp',
        },
        statusString: {
          label: '<i></i>',
          class: 'text-right',
          thStyle: {
            minWidth: '23em',
          },
        },
      },
    }
  },
  mounted: function() {
    var customs
    customRef.child('appointmentRequests').on('value', (snapshot) => {
      customs = []
      Object.entries(snapshot.val()).forEach(
        function([key, val]) {
          /* switch (val.userID.toString()) {
            case '1433106613393455':
              val.username = 'Kevin Loh'
              val.url = 'static/img/avatars/kevin.jpg'
              break
            case '2051557634917072':
              val.username = 'Ho Chin Chee'
              val.url = 'static/img/avatars/cc.jpg'
              break
            case '1510127159108428':
              val.username = 'Terry Chan'
              val.url = 'static/img/avatars/terry.jpg'
              break
            default:
              val.username = val.userID
              val.url = 'static/img/avatars/0.png'
              break
          } */
          customs.unshift({
            messageId: key,
            startDate: val.date,
            endDate: val.name,
            topic: val.time,
            phoneID: val.phoneNumber,
            // company: { name: val.surveyInfo.companyName, Id: val.surveyInfo.companyRegNo },
            timestamp: parseInt(val.timestamp),
            // loanAmount: numeral(val.surveyInfo.loanAmount).format('0,0'),
            // turnOverAmount: numeral(val.surveyInfo.turnover).format('0,0'),
            statusString: { formUrl: val.formUrl || 'https://firebasestorage.googleapis.com/v0/b/insurbot-5754a.appspot.com/o/appointment_281117.pdf?alt=media&token=3dc5f980-cba9-41c5-8eda-732246336bdb', mapUrl: val.location.googleMapsLink, carUrl: 'null', imageUrl: 'null' },
          })
        })
      console.log(customs)
      this.tableItems = customs
      this.loading = false
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/fragments/crmTable.vue?599267d4